// Données territoriales réutilisables — vitrine KDMARCHÉ PRO (/kdmarche)
export const TERRITORIES = [
  {
    id: 'guadeloupe',
    flag: '🇬🇵',
    name: 'Guadeloupe',
    tagline: 'Épicerie & restauration',
    color: '#8CC63E',
    zoneCode: 'GUADELOUPE',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/63d99c168d46193b268007603868e6a55016ef26ff835bd971c1597cb49f6360.jpeg',
    products: ['Riz parfumé 25 kg', 'Huile de tournesol 5 L', 'Sucre de canne 10 kg'],
  },
  {
    id: 'martinique',
    flag: '🇲🇶',
    name: 'Martinique',
    tagline: 'Hygiène & consommables',
    color: '#5B9BD5',
    zoneCode: 'MARTINIQUE',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/721b66adf1af58832e7ba0729379f4d26c82eff6d73dad73721720e355bce790.jpeg',
    products: ['Gel hydroalcoolique 5 L', 'Essuie-tout professionnel ×6', 'Sacs kraft 26×32 ×500'],
  },
  {
    id: 'guyane',
    flag: '🇬🇫',
    name: 'Guyane',
    tagline: 'BTP & équipements',
    color: '#E67E22',
    zoneCode: 'GUYANE',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/9e8c3045d9f4f74f673364a74f0fbf1af50f6dc06bcf8d74c26c994ce0eae240.jpeg',
    products: ['Ciment gris 35 kg', 'Gants nitrile chantier ×100', 'Bâche renforcée 4×6 m'],
  },
  {
    id: 'reunion',
    flag: '🇷🇪',
    name: 'La Réunion',
    tagline: 'Approvisionnements mixtes',
    color: '#D9B35A',
    zoneCode: 'REUNION',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/93f63091cc88faf3a553e91ad359a9c3f2c9d3332f97d48c20ff3d12423ba422.jpeg',
    products: ['Farine T55 25 kg', 'Boîtes alimentaires PP 1 L ×200', 'Café grain 5 kg'],
  },
  {
    id: 'mayotte',
    flag: '🇾🇹',
    name: 'Mayotte',
    tagline: 'Produits essentiels',
    color: '#B58CD9',
    zoneCode: 'MAYOTTE',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/604d72df83ff8fb12e7dadbe670a3f411d299e62442532ef91b16772e615aea2.jpeg',
    products: ['Lait en poudre 2,5 kg', 'Savon de Marseille 300 g ×24', 'Eau de source 1,5 L ×12'],
  },
  {
    id: 'iles-du-nord',
    flag: '🇫🇷',
    name: 'Îles du Nord',
    tagline: 'Commerce & restauration — Saint-Martin et Saint-Barthélemy',
    color: '#6FA82E',
    zoneCode: 'CARIBBEAN',
    image: 'https://static.prod-images.emergentagent.com/jobs/e00f0d9a-9698-4efd-a047-db50a9deb9d1/images/dbbb690483ea18fb2fff95b0df629135b9d424244e623192f18459b783fd4aaf.jpeg',
    products: ['Barquettes traiteur ×250', 'Vaisselle compostable ×100', 'Sirops parfumés 1 L'],
  },
];
